import { Filter } from '@/interfaces/filter.interface'
import { APIBlacklist } from '@/models/api/blacklist.model'
import { BlacklistsServices } from '@/services/modules/blacklists.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class BlacklistsStore extends VuexModule {
    blacklists: object[] = []
    blacklistsPaginate: object[] = []
    blacklistForm: object|null = null

    @Mutation
    updateBlacklists (newBlacklists: object[]) {
        this.blacklists = newBlacklists
    }

    @Mutation
    updateBlacklistsPaginate (newBlacklists: object[]) {
        this.blacklistsPaginate = newBlacklists
    }

    @Mutation
    updateBlacklist (newBlacklist: object) {
        this.blacklistForm = newBlacklist
    }

    @Action
    getBlacklists () {
        return new Promise((resolve) => {
            BlacklistsServices.getBlacklists()
                .then(resp => {
                    store.commit('updateBlacklists', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getBlacklistsPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit, sortBy: params.sortBy, sort: params.sort }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            BlacklistsServices.getBlacklistsPaginate(newParams)
                .then(resp => {
                    store.commit('updateBlacklistsPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getBlacklistsById (id: number) {
        return new Promise((resolve) => {
            BlacklistsServices.getBlacklistsById(id)
                .then(resp => {
                    store.commit('updateBlacklist', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editBlacklists (params: APIBlacklist) {
        params = new APIBlacklist(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIBlacklist)) {
                store.commit('reportError', { code: 1000, blacklist: 'Something went wrong :(' })
                resolve()
                return
            }

            BlacklistsServices.editBlacklists(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createBlacklists (params: APIBlacklist) {
        params = new APIBlacklist(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIBlacklist)) {
                store.commit('reportError', { code: 1000, blacklist: 'Something went wrong :(' })
                resolve()
                return
            }

            BlacklistsServices.createBlacklists(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteBlacklists (id: number) {
        return new Promise((resolve) => {
            BlacklistsServices.deleteBlacklists(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createBlacklistsFromFile (params: File) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, blacklist: 'Something went wrong :(' })
                resolve()
                return
            }

            BlacklistsServices.createBlacklistsFromFile(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteBlacklistsFromFile (params: File) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, blacklist: 'Something went wrong :(' })
                resolve()
                return
            }

            BlacklistsServices.deleteBlacklistsFromFile(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
